import React from "react";
import { Select } from "antd";
import AddAndFoundDoctorModalView from "./AddAndFoundDoctorModalView";

import { addNewDoctor, getDoctorsByPhoneNumber } from "../../../services";
import { openNotificationWithIcon, history } from "../../../helpers";

const { Option } = Select;

const pageNo = 1;
const perPage = 20;
export default class AddDoctorContainer extends React.Component {
  state = {
    phoneNumber: "",
    doctorId: "",
    selectedDoctor: "",
    isProcessing: false,
    doctors: [],
    searchText: "",
    openFoundDoctorModal: false,
    pageObj: {
      pageNo,
      perPage
    },
    fees: "",
    patients_per_hour: "",
    name: "",
    notFound: false
  };

  componentDidMount() {
    // this.getDoctors();
  }

  /**
   * @function getDoctors
   * @desc This function gets all doctors
   */
  getDoctors = () => {
    const { phoneNumber } = this.state;
    if (phoneNumber.length < 10) {
      this.setState({
        errorMsg: "Please enter a valid 10 digit mobile number",
        notFound: true
      });
      return;
    } else {
      this.setState({ errorMsg: "", notFound: false });
    }
    getDoctorsByPhoneNumber(phoneNumber).then(response => {
      if (response.data && response.data.success) {
        const { doctors } = response.data.data;
        this.setState(
          {
            notFound: false,
            errorMsg: "",
            selectedDoctor: doctors ? doctors[0] : ""
          },
          () => this.setState({ openFoundDoctorModal: true })
        );
      } else {
        this.setState({
          notFound: true,
          errorMsg:
            "We could not find any doctor on kulcare with this number. Add and invite them!"
        });
      }
    });
  };

  /**
   * @function onChangePhone
   * @desc Handle doctor phone change
   */
  onChangePhone = event => {
    if (event.target.value.length <= 10) {
      this.setState({ phoneNumber: event.target.value }, () => {
        this.setState({
          openFoundDoctorModal: false,
          selectedDoctor: "",
          notFound: false
        });
      });
    }
  };

  /**
   * @function onChangePph
   * @desc Handle doctor pph change
   */
  onChangePph = event => {
    this.setState({ patients_per_hour: event.target.value });
  };

  /**
   * @function onChangeName
   * @desc Handle doctor name change
   */
  onChangeName = event => {
    this.setState({ name: event.target.value });
  };

  /**
   * @function getOptions
   * @desc This function populates autocomplete (select doctor dropdown list) options
   */
  getOptions = () => {
    const { doctors } = this.state;
    if (doctors && doctors.length > 0) {
      const arrOptions = doctors.map((doctor, index) => {
        const doctorSpeciality = doctor.speciality
          ? `| ${doctor.speciality}`
          : "";
        return (
          <Option
            key={doctor.id}
            value={`${doctor.id}_${doctor.name}`}
            // doctors={doctors}
            label={`${doctor.name}`}
          >
            {`${doctor.name} ${doctorSpeciality} | ${doctor.country_code}-${doctor.phone_number}`}
          </Option>
        );
      });
      return arrOptions;
    }
  };

  /**
   * @function handleDoctorSelection
   * @param selectedDoctor
   * @desc This function handles doctor selection and set it in the state variables
   */
  handleDoctorSelection = selectedDoctor => {
    const doctorId = selectedDoctor.split("_")[0];
    const firstName = selectedDoctor.split("_")[1];
    const lastName = selectedDoctor.split("_")[2];
    this.setState({ doctorId });
    this.setState({ selectedDoctor: `${firstName} ${lastName}` });
  };

  /**
   * @function saveDoctorInfo
   * @desc This function handles saving selected doctor
   */
  saveDoctorInfo = () => {
    this.getDoctors();
  };

  addDoctorToAccount = () => {
    const { fees, selectedDoctor } = this.state;
    const { clinic } = this.props;
    // hit the add api here and show the success message
    const doctorObj = {
      doctor_id: selectedDoctor.id,
      fees
    };

    if (selectedDoctor) {
      this.setState({ isProcessing: true });
      addNewDoctor(clinic.id, doctorObj).then(response => {
        if (response.data && response.data.success) {
          this.closeAddDoctorModal();
          const doctorId = response.data.data.doctor.id;
          history.push(`/doctor-details/${doctorId}/basic-details`);
          this.props.getDoctorsListData(clinic.id);
          openNotificationWithIcon(
            "success",
            "Save Doctor",
            "Doctor info saved successfully"
          );
        } else {
          this.closeAddDoctorModal();
          this.setState({ isProcessing: false });
          const errorMsg = response.data.errors[0].title;
          openNotificationWithIcon("error", "Save Doctor", errorMsg);
        }
      });
    } else {
      openNotificationWithIcon(
        "error",
        "Save Doctor",
        "Please search and select a doctor"
      );
    }
  };

  /**
   * @function inviteDoctor
   * @desc This function send invite to non member
   */
  inviteDoctor = phoneNumber => {
    const { name, fees, patients_per_hour } = this.state;
    const { clinic } = this.props;
    if (!name.trim() || !fees.trim() || !patients_per_hour.trim()) {
      openNotificationWithIcon(
        "error",
        "Invite Doctor",
        "All Fields are required"
      );

      return;
    }
    // hit the add api here and show the success message
    const doctorObj = {
      phone_number: phoneNumber,
      name,
      fees,
      patients_per_hour
    };

    this.setState({ isProcessing: true });
    addNewDoctor(clinic.id, doctorObj).then(response => {
      if (response.data && response.data.success) {
        this.closeAddDoctorModal();
        const doctorId = response.data.data.doctor.id;
        history.push(`/doctor-details/${doctorId}/basic-details`);
        this.props.getDoctorsListData(clinic.id);
        openNotificationWithIcon("success", "Invite", "Invitation sent");
      } else {
        this.setState({ isProcessing: false });
        const errorMsg = response.data.errors[0].title;
        openNotificationWithIcon("error", "Save Doctor", errorMsg);
      }
    });
  };

  /**
   * @function confirmFoundDoctorModal
   * @desc This function handles closing "Found Doctor" modal
   */
  confirmFoundDoctorModal = () => {
    this.props.toggleFoundDoctorModal();
  };

  /**
   * @function resetForm
   * @desc This function handles resets state variables
   */
  resetForm = () => {
    this.setState({
      errorMsg: "",
      notFound: false,
      phoneNumber: "",
      doctorId: "",
      selectedDoctor: "",
      isProcessing: false,
      fees: "",
      searchText: "",
      patients_per_hour: "",
      name: ""
    });
  };

  /**
   * @function closeAddDoctorModal
   * @desc This function handles closing "Add Doctor" modal
   */
  closeAddDoctorModal = () => {
    this.resetForm();
    this.props.toggleAddDoctorModal();
  };

  /**
   * @function closeAddDoctorModal
   * @desc This function handles closing "Select Doctor" modal
   */
  closeFoundDoctorModal = () => {
    this.resetForm();
    this.props.toggleFoundDoctorModal();
  };

  /**
   * @function searchDoctor
   * @desc This function handles searching doctor
   */
  searchDoctor = () => {
    this.setState({ doctorId: "" });
  };

  /**
   * @function handleChange
   * @param searchText
   * @desc This function handles change in autocomplete input,
   * sets state variable and makes api call to to it
   */
  handleChange = searchText => {
    this.setState({ searchText });
    setTimeout(() => {
      this.getDoctors();
    }, 100);
  };

  /**
   * @function setFees
   * @param event
   * @desc This function handles setting fees state variable
   */
  setFees = event => {
    const fees = event.target.value;
    this.setState({ fees });
  };

  render() {
    const { openAddDoctorModal } = this.props;
    const {
      doctors,
      selectedDoctor,
      isProcessing,
      fees,
      searchText,
      phoneNumber,
      notFound,
      errorMsg,
      openFoundDoctorModal,
      patients_per_hour,
      name
    } = this.state;

    return (
      <div>
        <AddAndFoundDoctorModalView
          openFoundDoctorModal={openFoundDoctorModal}
          onChangePhone={this.onChangePhone}
          phoneNumber={phoneNumber}
          dataSource={doctors}
          openAddDoctorModal={openAddDoctorModal}
          closeAddDoctorModal={this.closeAddDoctorModal}
          getOptions={this.getOptions}
          handleDoctorSelection={this.handleDoctorSelection}
          saveDoctorInfo={this.saveDoctorInfo}
          selectedDoctor={selectedDoctor}
          searchDoctor={this.searchDoctor}
          isProcessing={isProcessing}
          handleChange={this.handleChange}
          setFees={this.setFees}
          fees={fees}
          searchText={searchText}
          notFound={notFound}
          errorMsg={errorMsg}
          addDoctor={this.addDoctorToAccount}
          modalTitle={"Search and add doctor"}
          extraFieldLabel={"Fees"}
          inviteDoctor={this.inviteDoctor}
          onChangeName={this.onChangeName}
          onChangePph={this.onChangePph}
          pph={patients_per_hour}
          name={name}
        />
      </div>
    );
  }
}
